import React from "react";
import styles from './Footer.module.css'
import { NavLink } from "react-router-dom";

export default function Footer(){
    return (
        <footer>
            <section>
                <h1>Seb Record</h1>
                <h2>Creative Web Developer</h2>
            </section>
            <section>
                <h4>Navigation</h4>
                <div className={styles.navLinks}>
                    <NavLink target="_top" to={'/home'}>Home</NavLink>
                    <NavLink target="_top" to={'/gallery'}>Gallery</NavLink>
                </div>
            </section>
            <section className={styles.socialSection}>
                <h4>Socials</h4>
                <div>
                    <a href="https://www.instagram.com/seabandreas"><img src={'./imgs/techIcons/insta.svg'}/></a>
                    <a href="https://www.linkedin.com/in/sebastian-record"><img src={'./imgs/techIcons/linkedin.svg'}/></a>
                </div>
            </section>
            {/* <section>
            </section> */}
        </footer>
    )
}